<template>
    <div class="image-bot-response" :class="{ empty: !defaultImageUrl }">
        <div class="placeholder" v-if="!defaultImageUrl && !selectedImage" @click="openSelectImage">
            <span class="material-icons"> photo_camera </span>
            <span>{{ $t("chatbotv2.dragAndDropBrowse") }}</span>
        </div>
        <div v-else class="position-relative" @mouseover="hovered = true" @mouseleave="hovered = false">
            <img class="preview" :src="defaultImageUrl" v-if="defaultImageUrl && !uploading" />
            <img class="preview" :src="selectedImageSrc" v-else-if="selectedImageSrc" />
            <div class="uploading-banner" v-if="uploading">
                <a-progress
                    type="circle"
                    :stroke-color="{
                        '0%': '#108ee9',
                        '100%': '#87d068',
                    }"
                    :percent="uploadProgress"
                />
                <span>{{ $t("chatbotv2.imageUploading") }} ...</span>
            </div>
            <div class="update-banner" v-if="defaultImageUrl && !uploading && hovered" @click="openSelectImage">
                <span class="material-icons"> photo_camera </span>
                <span>{{ $t("chatbotv2.clickToChooseNewImage") }}</span>
                <span
                    >{{ $t("chatbotv2.or") }}
                    <span class="remove" @click="removeImage">{{ $t("chatbotv2.removeTheExistingOne") }}</span></span
                >
            </div>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../../utils/log2";
import { uploadAsset } from "../../../../../../../api/assetUpload";
import mimeTypes from "../../../../../../../components/util/mimeTypes";
import { getExtensionFromFileName } from "../../../../../../../utils/utils";
import axios from "axios";
import { mapState } from "vuex";
import * as _ from "lodash";

const log = log2("ImageBotResponse");
export default {
    name: "ImageBotResponse",
    props: ["defaultImageUrl", "defaultAssetId", "onUpdated", "whatsappMode", "allowedAttributes"],
    data() {
        return {
            selectedImage: null,
            selectedImageSrc: null,
            uploading: false,
            uploadProgress: 0,
            hovered: false,
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
            site: (state) => state.site.site,
        }),
    },
    methods: {
        openSelectImage() {
            let fileEl = document.createElement("input");
            fileEl.setAttribute("type", "file");
            fileEl.setAttribute("accept", "image/*");

            fileEl.onchange = async () => {
                let file = fileEl.files[0];
                const fileType = getExtensionFromFileName(file.name);
                if (file) {
                    this.selectedImage = file;
                    this.selectedImageSrc = URL.createObjectURL(file);
                    this.uploading = true;
                    let path = `${this.site._id}/chatbot-file/`;

                    let { data } = await uploadAsset({
                        path,
                        mime: file.type,
                        name: file.name,
                        ext: mimeTypes[file.type] || fileType || "supsis",
                    });
                    log("file", { file, data });
                    if (file.size <= 10 * 1024 * 1024) {
                        axios({
                            method: data.method,
                            url: data.url,
                            data: file,
                            headers: {
                                "Content-Type": file.type,
                            },
                            onUploadProgress: (p) => {
                                const percent = Math.round((p.loaded * 100) / p.total);
                                this.uploadProgress = percent;
                            },
                        })
                            .then((res) => {
                                this.$message.success({
                                    content: `Image uploaded successfully`,
                                    duration: 2,
                                    key: "uploading",
                                });
                                this.onUpdated({
                                    assetId: data.asset._id,
                                    imageUrl: `https://static.supsis.live/${data.asset.path}${data.filename}`,
                                });
                            })
                            .catch((err) => {
                                this.$message.error({
                                    content: "Image upload failed",
                                    duration: 2,
                                    key: "uploading",
                                });
                            })
                            .finally(() => {
                                this.uploading = false;
                                this.selectedImage = null;
                                this.selectedImageSrc = null;
                                this.hovered = false;
                            });
                    } else {
                        log.warn("input is not suitable for send");
                        this.$message.error({
                            content: this.$t("message.assetOversize"),
                            duration: 2,
                            key: "uploading",
                        });
                        this.uploading = false;
                        this.selectedImage = null;
                        this.selectedImageSrc = null;
                        this.hovered = false;
                    }
                } else {
                    this.selectedImage = null;
                    this.selectedImageSrc = null;
                    this.uploading = false;
                    this.hovered = false;
                }
            };
            fileEl.click();
        },
        removeImage(e) {
            e.preventDefault();
            e.stopPropagation();
            this.onUpdated({
                assetId: null,
                imageUrl: null,
            });
        },
    },
    watch: {
        defaultImageUrl(val) {
            log("defaultImageUrl changed", val);
        },
    },
};
</script>

<style scoped lang="scss">
.image-bot-response {
    max-width: 100%;
    width: 325px;
    height: 260px;
    border-radius: 8px;
    background: #f0f4f7;
    display: flex;
    justify-content: center;
    align-items: center;

    .placeholder {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
    }

    img.preview {
        width: 325px;
        height: 260px;
        object-fit: cover;
    }

    .uploading-banner {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(240, 244, 247, 0.99);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .update-banner {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 108, 255, 0.6);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        span {
            color: white;

            &.remove {
                text-decoration: underline;
            }
        }
    }

    &.empty {
        &:hover {
            cursor: pointer;
            background-color: #006cff;
            opacity: 0.8;
            color: white;

            .placeholder {
                color: white;
            }
        }
    }
}
</style>
